import { useRouter } from 'next/router';
import { withDefaultOrigin } from '@packages/shared/core/common/utils/url';

export const useDefaultCanonicalUrl = () => {
  const router = useRouter();

  const defaultCanonicalUrl = withDefaultOrigin(router.asPath).split('?')[0];

  return {
    defaultCanonicalUrl,
  };
};
